import axios from "@/api/axiosAuthRequired.js"
import axiosAuthRequired from "./axiosAuthRequired"

const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

const getAuthHeaders = () => {
  let headers = {}
  let clientCredentials = window.localStorage.getItem("client_credentials")
  if (clientCredentials) {
    headers["Authorization"] = "Bearer " + clientCredentials
  }

  return headers
}

export const fetchComments = (type, id) => {
  let url = PROGUIDES_WEB_URL + "api/v2/community/discussion/" + type + "/" + id
  return axiosAuthRequired({
    method: "get",
    url: url,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const postComment = (type, id, comment) => {
  let url =
    PROGUIDES_WEB_URL +
    "api/v2/community/discussion/" +
    type +
    "/" +
    id +
    "/comments"

  let body = new FormData()
  body.append("comment", comment.text)

  if (comment.parent_comment_id) {
    body.append("parent_comment_id", comment.parent_comment_id)
  }
  if (comment.language) {
    body.append("language", comment.language)
  }

  return axiosAuthRequired({
    method: "post",
    url: url,
    data: body,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const postCommentVote = (id, vote) => {
  let url =
    PROGUIDES_WEB_URL + "api/v2/community/voteable/comment/" + id + "/votes"

  let body = new FormData()
  body.append("action", vote)

  return axiosAuthRequired({
    method: "post",
    url: url,
    data: body,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchVoteable = (type, id) => {
  return axios({
    method: "get",
    url: "/api/v2/community/voteable/" + type + "/" + id + "/votes",
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const postVoteableVote = (type, id, vote) => {
  let body = new FormData()
  body.append("action", vote)

  return axiosAuthRequired({
    method: "post",
    url: "/api/v2/community/voteable/" + type + "/" + id + "/votes",
    data: body,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./src/api/comments.js